module.exports = __webpack_public_path__ + "img/4.15fddc31.jpg";